module.exports = "/_next/static/videos/snowboarding-2-00d4e4b3bc0fe8a3cdc4109893dc5241.webm";